import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
} from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { ErrorDetail } from '@services/error.service';
import { RATE_LIMIT_DEFAULT_SECONDS } from '@utils/httpError';

@Component({
  selector: 'app-error-message',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './error-message.component.html',
  styleUrl: './error-message.component.css',
})
export class ErrorMessageComponent implements OnChanges, OnDestroy {
  @Input() detail: ErrorDetail | null = { kind: 'generic' };
  @Output() buttonClickPrimary = new EventEmitter<Event>();
  @Output() buttonClickSecondary = new EventEmitter<Event>();

  isResultsPage = !window.location.href.includes('/results');
  secondsLeft = 0;
  private timer?: ReturnType<typeof setInterval>;

  get isRateLimit(): boolean {
    return this.detail?.kind === 'rate-limit';
  }

  get retryText(): string {
    return this.secondsLeft > 0
      ? `VOLVER A INTENTAR (${this.secondsLeft}s)`
      : 'VOLVER A INTENTAR';
  }

  ngOnChanges() {
    this.stopTimer();
    this.secondsLeft = this.isRateLimit
      ? (this.detail?.retryAfterSeconds ?? RATE_LIMIT_DEFAULT_SECONDS)
      : 0;
    if (this.secondsLeft > 0) {
      this.timer = setInterval(() => {
        this.secondsLeft--;
        if (this.secondsLeft <= 0) this.stopTimer();
      }, 1000);
    }
  }

  ngOnDestroy() {
    this.stopTimer();
  }

  onClickPrimary(event: Event) {
    this.buttonClickPrimary.emit(event);
  }
  onClickSecondary(event: Event) {
    if (this.secondsLeft > 0) return;
    this.buttonClickSecondary.emit(event);
  }

  private stopTimer() {
    if (this.timer) clearInterval(this.timer);
    this.timer = undefined;
  }
}
